export default "__VITE_ASSET__Dik77OWI__"